module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_found"
  }, [_c('div', {
    staticClass: "found"
  }, [_vm._v("404 Not Found \n        "), _c('div'), _vm._v(" "), _c('span', [_vm._v("您访问的页面不存在")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0100f1ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 523
// module chunks = 2